import { render, staticRenderFns } from "./ColorSlider.vue?vue&type=template&id=6d31ba5e&scoped=true&"
import script from "./ColorSlider.vue?vue&type=script&lang=js&"
export * from "./ColorSlider.vue?vue&type=script&lang=js&"
import style0 from "./ColorSlider.vue?vue&type=style&index=0&id=6d31ba5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31ba5e",
  null
  
)

export default component.exports